module.exports = __webpack_public_path__ + "static/media/gallery-10.fd542dab.JPG";